import { z } from 'zod/v4-mini';

import { User, userSchema } from '@/models/UserModel';
import { Schema } from '@/utils/zodUtils.ts';

/*********************************
 *         Self Patient          *
 *********************************/

export type SelfPatient = {
  id: string;
  user: User;
  givenName: string;
  familyName: string;
};

export const selfPatientSchema: Schema<SelfPatient> = z.pipe(
  z.object({
    user: userSchema,
    givenName: z.string(),
    familyName: z.string(),
  }),
  z.transform(data => ({ ...data, id: data.user.id })),
);
